import React from "react";
import s from "./NewsItem.module.scss";
import { Link } from "react-router-dom";
import {
  ArrowRightOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { toTitleCase } from "../../textUtils";
import { useDispatch, useSelector } from "react-redux";
import { getNewsDetails } from "../../../../redux/LangingPageSlice";

const normalize = (text) => (text || "").trim().toLowerCase();

const NewsItem = ({ news, to }) => {
  const dispatch = useDispatch();
  const events = useSelector((state) => state.landing.events);
  const isEvent = news.category?.name === "events";

  const event = isEvent
    ? events?.find(
        (e) =>
          (news.event_id && String(e.id) === String(news.event_id)) ||
          normalize(e.title) === normalize(news.title),
      )
    : null;
  const link = to
    ? to
    : isEvent
      ? event
        ? `/events/${event.id}`
        : "/events"
      : `/news/${news.id}`;

  return (
    <div
      className={s.news}
      onClick={() => {
        // the event page loads its own details and photos
        if (!isEvent && !to) dispatch(getNewsDetails(news.id));
      }}
    >
      <Link to={link}>
        <div className={s.img_wrapper}>
          {news.image ? (
            <img src={news?.image} className={s.img} alt="" />
          ) : (
            <img src={"/images/image.png"} className={s.noimg} alt="" />
          )}
        </div>
        <div className={s.text}>
          {news?.additional_title && (
            <div className={s.subtitle}>{news.additional_title}</div>
          )}
          <div className={s.title}>{toTitleCase(news?.title)}</div>
          {news?.description && (
            <div className={s.description}>{news.description}</div>
          )}
          {news?.location && (
            <div className={s.location}>
              <EnvironmentOutlined className={s.icon} />
              {news.location}
            </div>
          )}
          <div className={s.footer}>
            <span className={s.date}>
              <CalendarOutlined className={s.date_icon} />
              {news?.created_at}
            </span>
            <span className={s.more}>
              Read more
              <span className={s.more_icon}>
                <ArrowRightOutlined />
              </span>
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default NewsItem;
